import { apiPost } from './client'
import type { ApiResponse } from '@crm/shared'

export async function importCSV(
  objectId: string,
  file: File,
  fieldMapping: Array<{ csv_column: string; field_name: string }>,
): Promise<ApiResponse<{ success_count: number; fail_count: number; errors: Array<{ row_number: number; error: string }> }>> {
  const API_BASE = import.meta.env.VITE_API_BASE || '/api/v1'
  const token = (await import('../stores/auth.store')).useAuthStore.getState().token

  const formData = new FormData()
  formData.append('file', file)
  formData.append('object_id', objectId)
  formData.append('field_mapping', JSON.stringify(fieldMapping))

  const res = await fetch(`${API_BASE}/settings/import`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: { message: res.statusText } }))
    throw new Error(err.error?.message || 'Import failed')
  }

  return res.json()
}
